import { render, staticRenderFns } from "./promotions-list.vue?vue&type=template&id=6dc865d2&scoped=true"
import script from "./promotions-list.vue?vue&type=script&lang=js"
export * from "./promotions-list.vue?vue&type=script&lang=js"
import style0 from "./promotions-list.vue?vue&type=style&index=0&id=6dc865d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc865d2",
  null
  
)

export default component.exports